module.exports = __webpack_public_path__ + "static/media/Game_Default_Thumnail.981229c7.png";